module.exports = __webpack_public_path__ + "img/ecardinactive.1aa89dea.png";